import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map, shareReplay } from 'rxjs/operators'
 
const CONTENT_PATH = 'content'
 
@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private readonly contentObservable: Observable<any>
  constructor(private readonly http: HttpClient) {
    this.contentObservable = http
      .get<any>(CONTENT_PATH)
      .pipe(shareReplay());
  }
 
  public getContent(): Observable<any> {
    return this.contentObservable.pipe(
      map((response) => {
        return response
      }),
    )
  }
}
